import styled from "styled-components";

export const SignInContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 380px;
`;

export const SignInHeading = styled.h2`
  margin: 10px 0;
`;

export const SignInButton = styled.div`
  display: flex;
  justify-content: space-around;
`;
